/* eslint-disable import/prefer-default-export */
import { SET_CITY_LIST } from 'Redux/actions/types';

export const setCityList = (cityList) => ({
  type: SET_CITY_LIST,
  payload: cityList,
});
